import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';

@Component({
  selector: 'kt-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.css']
})
export class PaymentMethod implements OnInit {
  @Input() btnCancelText: string = 'Cancel';
  @Input() title: string;
  public type:string;
  public selectedMethod:any;
  public instruction:any;
  public showError : boolean = true;
  constructor(private dialogRef: MatDialogRef<PaymentMethod>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private sharedService:SharedService,
  private router: Router,) { }

  ngOnInit() {
    // this.title = this.data ? this.data.title:'';
    // this.type = this.data ? this.data.type:'';
    // this.instruction = this.data ?this.data.instruction:'';

    // if (this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES) {
    // this.instruction = this.data ?this.data.instruction:'';
    //  }else if (this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES) {
    //   this.instruction = '';
    // }
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  public accept() {
    console.log(this.selectedMethod)
    this.dialogRef.close(true);
  }
  public decline() {
    this.dialogRef.close(-1);
  }

  public onButtonSubmit()
  {
    if(this.selectedMethod == 1)
    {
      this.sharedService
      .openPopupDialog(
        'Admin Screen','Dear applicant after selecting payment mode 1 Link Online Payment 1BILL option you can not change to manual fee submission','warning','CONFIRM'
      )
      .then((res) => {
        if(res)
        {
          this.dialogRef.close(true);
        }
        //console.log(res)
      });
    }
    else this.dialogRef.close(false);
    

  }

  public getRadioSelection(event)
  {
    console.log(event)
    this.showError = false
  }

  // public readMore(){
  //   this.instruction = this.data ?this.data.instruction:'';

  // }

  // public readLess(){
  //   this.instruction = ''
  // }

}
